// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

export enum LoadWeigherStatus {
  Light = 0,
  Normal = 1,
  Dispatch = 2,
  Heavy = 3,
  Overload = 4
}
